<template>
  <div :class="$style.newsletterWrapper">
    <section :class="$style.newsletter">
      <lv-heading tag="h3" :level="mediaQueries['md-min'] ? '5' : '6'" regular>
        {{ $awt('aw.common.unsubscribe.title') }}
      </lv-heading>
      <div :class="$style.description" v-html="$awt('aw.common.unsubscribe.description')" />
      <br>
      <aw-unsubscribe-form />
    </section>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import AwUnsubscribeForm from '~~/shop/app/components/Page/Unsubscribe/AwUnsubscribeForm.vue';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';
  import { defineI18nRoute } from '#i18n';

  defineOptions({
    name: 'Unsubscribe',
  });

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/unsubscribe',
      hu: '/hirlevel-leiratkozas',
    },
  });

  const userInterfaceStore = useUserInterfaceStore();
  const mediaQueries = computed(() => userInterfaceStore.mediaQueries);
</script>

<style module lang="scss">

.newsletterWrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  .newsletter {
    width: 100%;
    padding: 16px;
    border-radius: 8px;
    background: $color-white;
    @include md() {
      width: 50%;
      padding: 24px;
    }
  }

  .description {
    padding: 8px 0 16px;
  }
}
</style>
